export default __webpack_public_path__ + "static/media/img_download.0ef9c68f.svg";